/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Device caps for a campaign
*/
export class V3CampaignDeviceCaps {
    /**
    * Desktop cap percentage. Valid range is 0-1
    */
    'desktop'?: number;
    /**
    * Mobile web cap percentage. Valid range is 0-1
    */
    'web'?: number;
    /**
    * In-app cap percentage. Valid range is 0-1
    */
    'app'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "desktop",
            "baseName": "desktop",
            "type": "number",
            "format": "float"
        },
        {
            "name": "web",
            "baseName": "web",
            "type": "number",
            "format": "float"
        },
        {
            "name": "app",
            "baseName": "app",
            "type": "number",
            "format": "float"
        }    ];

    static getAttributeTypeMap() {
        return V3CampaignDeviceCaps.attributeTypeMap;
    }

    public constructor() {
    }
}

